export enum SearchFilterDefaultValueEnum {
  'SÉJOUR' = 'SÉJOUR',
  'TousLesAéroports' = 'Tous les aéroports',
  'NImporteQuand' = "N'importe quand",
  'PeuImporte' = 'Peu importe',
}
